import { useState, useEffect, useContext } from "react";
import { Grid, Stack, Box, GTIWebSelect, GTIWebDataGrid} from "@gti-controls-v2/web-core";
import useSearch from "../../../hooks/useSearch";
import useLookup from "../../../hooks/useLookups";
import { SettingsContext } from "../../../providers/settings";
import { formatDateGrid } from "../../../common/utilities/dateTime";
import homePageStyles from "../../../common/styles/HomePage";
import DateRangeFilter from "../../../components/date-range-filter";

const Payrolls = ({ CURP, data}) => {
    const styles = homePageStyles;
    const dateFormat = "DD/MMM/YYYY";
    const today = new Date(new Date().toLocaleString("en-US", {timeZone: "PST"}));
    const lastYear = new Date(today);
    lastYear.setFullYear(today.getFullYear() - 1);

    const { handleLoading } = useContext(SettingsContext);
    const { getPayrolls } = useSearch();
    const { getPayrollsStatus } = useLookup();
    const [payrolls, setPayrolls] = useState([]);
    const [payrollsStatus, setPayrollsStatus] = useState(null);
    const [status, setStatus] = useState(0);
    const [dateRange, setDateRange] = useState({
        startDate: lastYear.toISOString().split('T')[0],
        endDate: today.toISOString().split('T')[0]
    });
    const [flag, setFlag] = useState(false);

    useEffect(() => {
        init();
        // eslint-disable-next-line
    }, [data]);

    const init = async () => {
        if (!flag) {
            const resultPayrollStatus = getPayrollsStatus();
            setPayrollsStatus(resultPayrollStatus.data);

            setPayrolls(data);
            setFlag(true);
        }
    };

    useEffect(() => {
        getPayrollsHandler();
        //eslint-disable-next-line
    }, [dateRange, status]);

    const getPayrollsHandler = async() => {
        if (CURP.length > 0 && payrollsStatus !== null && flag) {
            handleLoading(true);

            const resultPayrolls = await getPayrolls(CURP, dateRange.startDate, dateRange.endDate, status);
            
            if (resultPayrolls.exitoso) { 
                setPayrolls(resultPayrolls.data);
            } else {
                setPayrolls([]);
            }

            handleLoading(false);
        }
    };

    const onChangeFiltroPayroll = async (event) => {
        if (!flag) return;
        switch (event.target.name) {
            case "statusPayrolls":
                setStatus(event.target.value);
                break;
            case "dateRange":
                console.log("onChangeFiltroPayroll -> dateRange:", event.target.value);
                setDateRange(event.target.value);
                break;
            default:
                break;
        }
    };

    const payrollsGridColumns = [
        { field: "EmpresaNombre", headerName: "Empresa", width: 250 },
        { field: "EmpreaRFC", headerName: "RFC", width: 150 },
        { field: "PeriodoNombre", headerName: "Periodo", width: 150 },
        { 
            field: "FacturaFecha", 
            headerName: "Timbrado", 
            width: 220, 
            sortComparator: (v1, v2) => {
                let date1 = new Date(v1);
                let date2 = new Date(v2);

                return date1.getTime() - date2.getTime()
            },
            valueFormatter: formatDateGrid
        },
        { field: "NominaStatusDesc", headerName: "Estatus", width: 100 },
    ];

    return (
        <Grid>
            <Stack direction="row" spacing={3} sx={styles.payrollsContainer}>
                <Stack direction="column" sx={styles.payrollsLookup}>
                    <Box>
                        <GTIWebSelect
                            name="statusPayrolls"
                            dataSource={payrollsStatus}
                            displayedValue="statusDesc"
                            selectedValue="statusId"
                            labelText="Estatus de Nómina"
                            value={status}
                            onChange={onChangeFiltroPayroll}
                        />
                    </Box>
                </Stack>

                <Stack direction="column" sx={styles.supportDatePicker}>
                    <DateRangeFilter 
                        name={"dateRange"}
                        labelStart={"Fecha inicial:"}
                        labelEnd={"Fecha final:"}
                        labelTo={"-"}
                        dateFormat={dateFormat}
                        onChange={onChangeFiltroPayroll}
                        value={dateRange} 
                    />
                </Stack>

            </Stack>
            <Box>
                <br/>
                <Grid container>
                    <GTIWebDataGrid 
                        pageSize={20}
                        rows={payrolls}
                        columns={payrollsGridColumns}
                        getRowId={(r) => r.id}
                    />
                </Grid>
            </Box>
        </Grid>
    );
};

export default Payrolls;